import { createContext, useContext } from 'react';

/**
 * Replacements for navigations that components make after an action, for views
 * that embed those components and must stay put (e.g. Mission Control
 * embedding issue details). Each handler that is set is called instead of
 * that navigation; unset ones navigate as usual.
 */
export type NavigationOverrides = Readonly<{
    /** instead of navigating to the issue, once its Draft is published */
    onDraftIssuePublished?: (issueId: string) => void;
    /** instead of navigating to the Draft issues list, once a Draft is removed */
    onDraftIssueRemoved?: (issueId: string) => void;
}>;

const NavigationOverridesContext = createContext<NavigationOverrides>({});

/**
 * Overrides navigations made by descendants.
 * @type {NavigationOverrides}
 */
export const NavigationOverridesProvider = NavigationOverridesContext.Provider;

export function useNavigationOverrides(): NavigationOverrides {
    return useContext(NavigationOverridesContext);
}
